(() => {
  const hasGeneratedContent = (value) => {
    return Boolean(value && !['none', 'normal', '""', "''"].includes(value));
  };

  const refreshStarFallback = (root) => {
    root.classList.remove('er-review-stars-fallback');

    const star = root.querySelector('.jdgm-star');
    if (!star) return;

    const text = star.textContent.trim();
    const styles = window.getComputedStyle(star);
    const before = window.getComputedStyle(star, '::before').content;
    const after = window.getComputedStyle(star, '::after').content;
    const hasBackground = styles.backgroundImage && styles.backgroundImage !== 'none';
    const hasNativeGlyph = Boolean(text || hasBackground || hasGeneratedContent(before) || hasGeneratedContent(after));

    root.classList.toggle('er-review-stars-fallback', !hasNativeGlyph);
  };

  const formatReviewDate = (value) => {
    if (!value) return '';

    const normalized = value.trim().replace(/\s+UTC$/i, 'Z').replace(' ', 'T');
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return value.split(' ')[0] || value;

    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }).format(date);
    } catch (_error) {
      return value.split(' ')[0] || value;
    }
  };

  const renderReviewDates = (root) => {
    root.querySelectorAll('.jdgm-rev__timestamp[data-content]').forEach((timestamp) => {
      if (timestamp.textContent.trim()) return;

      const formatted = formatReviewDate(timestamp.dataset.content);
      if (!formatted) return;

      timestamp.textContent = formatted;
      timestamp.classList.remove('jdgm-spinner');
      timestamp.dataset.erDateFallback = 'true';
    });
  };

  const scheduleReviewRefresh = (root) => {
    [0, 350, 1200].forEach((delay) => {
      window.setTimeout(() => {
        refreshStarFallback(root);
        renderReviewDates(root);
      }, delay);
    });
  };

  const getVisibleOfficialModal = () => {
    const candidates = document.querySelectorAll('.jm-mfp-wrap, .jdgm-modal, [class*="jdgm"][class*="modal"]');
    return [...candidates].some((element) => {
      const styles = window.getComputedStyle(element);
      return styles.display !== 'none' && styles.visibility !== 'hidden' && Number.parseFloat(styles.opacity || '1') > 0;
    });
  };

  const openFallbackLightbox = (source, alt) => {
    let dialog = document.querySelector('.er-review-lightbox');

    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'er-review-lightbox';
      dialog.innerHTML = '<button class="er-review-lightbox__close" type="button" aria-label="Close review photo">&times;</button><img class="er-review-lightbox__image" alt="">';
      document.body.append(dialog);

      dialog.querySelector('.er-review-lightbox__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    const image = dialog.querySelector('.er-review-lightbox__image');
    image.src = source;
    image.alt = alt || 'Customer review photo';

    if (!dialog.open) dialog.showModal();
  };

  const enableMediaFallback = (root) => {
    if (root.dataset.erMediaFallback === 'true') return;
    root.dataset.erMediaFallback = 'true';

    root.addEventListener('click', (event) => {
      const link = event.target.closest('.jdgm-rev__pic-link');
      if (!link || !root.contains(link)) return;

      const image = link.querySelector('.jdgm-rev__pic-img, img');
      const rawHref = link.getAttribute('href');
      const usableHref = rawHref && !rawHref.startsWith('#') && !rawHref.toLowerCase().startsWith('javascript:');
      const source = usableHref ? link.href : (image?.currentSrc || image?.src);
      if (!source) return;

      event.preventDefault();
      window.setTimeout(() => {
        if (!getVisibleOfficialModal()) openFallbackLightbox(source, image?.alt);
      }, 220);
    });

    root.addEventListener('click', (event) => {
      if (!event.target.closest('.jdgm-paginate__page')) return;
      scheduleReviewRefresh(root);
    });
  };

  const enhanceReviewSummary = (root) => {
    const widget = root.querySelector('.jdgm-rev-widg');
    const summary = root.querySelector('.jdgm-rev-widg__summary');
    const body = root.querySelector('.jdgm-rev-widg__body');
    const sort = root.querySelector('.jdgm-rev-widg__sort-wrapper');

    if (!widget || !summary) return false;

    enableMediaFallback(root);
    refreshStarFallback(root);
    renderReviewDates(root);

    if (body && sort && sort.parentElement !== body) {
      body.prepend(sort);
    }

    if (summary.querySelector('.er-review-average')) return true;

    const rawRating = widget.dataset.averageRating;
    const rating = Number.parseFloat(rawRating);
    if (!Number.isFinite(rating) || rating <= 0) return true;

    const average = document.createElement('span');
    average.className = 'er-review-average';
    average.textContent = `${rating.toFixed(2)} / 5`;
    average.setAttribute('aria-hidden', 'true');
    summary.prepend(average);
    return true;
  };

  const enhanceAll = () => {
    const roots = [...document.querySelectorAll('#judgeme_product_reviews')];
    return roots.length > 0 && roots.every(enhanceReviewSummary);
  };

  const start = () => {
    const refreshStars = () => {
      document.querySelectorAll('#judgeme_product_reviews').forEach((root) => {
        refreshStarFallback(root);
        renderReviewDates(root);
      });
    };

    [0, 600, 2200, 6000].forEach((delay) => window.setTimeout(refreshStars, delay));

    if (enhanceAll()) return;

    const observer = new MutationObserver(() => {
      if (enhanceAll()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
